import React, { memo, useCallback } from "react";

import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";
import useEditMessageThreadIsLocked from "modules/hooks/use-edit-message-thread-is-locked";
import {
  MIXPANEL_EVENT_TYPE,
  useMixpanel,
} from "../providers/mixpanel-provider/mixpanel-provider";
import { UnlockedOutlineIcon } from "modules/icons";
import ModalTitle from "./modal-title";
import colors from "app/colors";
import { useOverlay } from "modules/providers/overlay-provider";

interface IProps {
  messageThreadId: string;
}

const ConfirmUnlockConversationModal = ({ messageThreadId }: IProps) => {
  const { closeModal } = useOverlay();
  const [unlockConversationAPI] = useEditMessageThreadIsLocked(
    messageThreadId,
    false,
  );

  const { track } = useMixpanel();

  const onUnlockClicked = useCallback(() => {
    unlockConversationAPI();
    track(MIXPANEL_EVENT_TYPE.LOCK_CONVERSATION_TOGGLED, {
      "Conversation Locked": false,
      "New Conversation": false,
    });
    closeModal();
  }, [unlockConversationAPI, track, closeModal]);

  return (
    <Modal isOpen onClose={closeModal} isCentered size="sm">
      <ModalOverlay />
      <ModalContent borderRadius={16}>
        <ModalBody p={6}>
          <VStack spacing={4}>
            <ModalTitle
              text="Remove Private Setting?"
              icon={<UnlockedOutlineIcon boxSize={16} />}
            />
            <Text textAlign="center" fontSize="sm" color={colors.gray50}>
              Removing this setting from this thread will allow everyone with
              access to add users and groups.
            </Text>
            <HStack>
              <Button variant="cancel" height={8} w={28} onClick={closeModal}>
                Cancel
              </Button>
              <Button height={8} w={28} onClick={onUnlockClicked}>
                Remove
              </Button>
            </HStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default memo(ConfirmUnlockConversationModal);
